export default __webpack_public_path__ + "static/media/loading-table.764be890.gif";